import { Component, OnInit, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { isString } from 'ngx-cookie';
import { AppService } from '../../../app.service';
declare let d3;

@Component({
  selector: 'si-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.scss']
})
export class KpiComponent implements OnInit {

  @Input() title: string;
  @Input() kpiValue: number;
  @Input() percent?: number;
  @Input() colorClass?: string;

  constructor(private appService: AppService) { }

  ngOnInit() {
  }

  shortenLargeNumber(num, digits) {
    let SI_SYMBOL, tier, suffix, scale, scaled;
    SI_SYMBOL = ['', 'K', 'M', 'B', 'T', 'P', 'E'];
    // what tier? (determines SI symbol)
    // tslint:disable:no-bitwise
    tier = Math.log10(num) / 3 | 0;

    // if zero, we don't need a suffix
    if (tier === 0) { return num; }

    // get suffix and determine scale
    suffix = SI_SYMBOL[tier];
    scale = Math.pow(10, tier * 3);

    // scale the number
    scaled = num / scale;
    // format number, check if precision zero and add suffix
    return scaled.toFixed(1) + suffix;

  }

}
